import { Injectable, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';
import { emailConfigData, EmailSenderComponent } from 'src/app/core/component/email-sender/email-sender.component';
import { SearchModalComponent } from 'src/app/core/component/search-modal/search-modal.component';
import { infoModalData } from 'src/app/core/helper/core.data.interface';
import { InfoModalComponent } from '../feature-modal/info-modal/info-modal.component';
import { ConfirmModalComponent } from '../form/component/confirm-modal/confirm-modal.component';
import { confirmModalData, searchModal } from '../interface/modal-interface';
import { Subject } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  modalRef: BsModalRef = {} as BsModalRef;
  currentUrl: any = { url: '' };
  private readonly openModalTailwindClass = [
    'flex',
    'items-center',
    'min-h-[calc(100vh-1rem)]',
    '!my-2',
    'max-sm:!w-[calc(100vw-1rem)]',
    'max-sm:!max-w-[calc(100vw-1rem)]',
    '[&_.modal-dialog]:overflow-visible',
    // '[&_.modal-content]:overflow-hidden',
    // '[&_.modal-content]:max-h-[calc(100vh-1rem)]',
    // '[&_.modal-content]:overflow-hidden',
    '[&_.modal-content]:overflow-visible',
    '[&_.modal-content]:flex',
    '[&_.modal-content]:flex-col',
    '[&_.modal-content]:border-0',
    // '[&_.modal-content]:rounded-2xl',
    '[&_.modal-content]:!rounded-2xl',
    '[&_.modal-content]:!rounded-t-2xl',
    '[&_.modal-content]:!rounded-b-2xl',
    '[&_.modal-content]:bg-white',
    '[&_.modal-content]:shadow-2xl',
    '[&_.modal-header]:items-center',
    '[&_.modal-header]:border-0',
    '[&_.modal-header]:border-b',
    '[&_.modal-header]:border-solid',
    '[&_.modal-header]:border-slate-100',
    '[&_.modal-header]:!bg-white',
    '[&_.modal-header]:!text-slate-900',
    '[&_.modal-header]:!rounded-t-2xl',
    '[&_.modal-header]:overflow-hidden',
    '[&_.modal-header]:px-5',
    '[&_.modal-header]:py-4',
    '[&_.modal-title]:m-0',
    '[&_.modal-title]:text-lg',
    '[&_.modal-title]:font-bold',
    '[&_.modal-title]:leading-tight',
    '[&_.modal-title]:text-slate-900',
    '[&_.close]:ml-auto',
    '[&_.close]:flex',
    '[&_.close]:h-9',
    '[&_.close]:w-9',
    '[&_.close]:items-center',
    '[&_.close]:justify-center',
    '[&_.close]:rounded-full',
    '[&_.close]:border-0',
    '[&_.close]:bg-slate-100',
    '[&_.close]:p-0',
    '[&_.close]:text-xl',
    '[&_.close]:leading-none',
    '[&_.close]:text-slate-500',
    '[&_.close]:opacity-100',
    '[&_.close]:shadow-none',
    '[&_.close]:[text-shadow:none]',
    '[&_.close_span]:block',
    '[&_.close_span]:leading-none',
    '[&_.close_i]:block',
    '[&_.close_i]:leading-none',
    '[&_.close:hover]:bg-slate-200',
    '[&_.close:hover]:text-slate-700',
    '[&_.btn-close]:ml-auto',
    '[&_.btn-close]:flex',
    '[&_.btn-close]:h-9',
    '[&_.btn-close]:w-9',
    '[&_.btn-close]:items-center',
    '[&_.btn-close]:justify-center',
    '[&_.btn-close]:rounded-full',
    '[&_.btn-close]:border-0',
    '[&_.btn-close]:bg-slate-100',
    '[&_.btn-close]:p-0',
    '[&_.btn-close]:text-slate-500',
    '[&_.modal-body]:border-0',
    '[&_.modal-body]:bg-white',
    '[&_.modal-body]:p-5',
    // '[&_.modal-body]:overflow-y-auto',
    // '[&_.modal-body]:overflow-x-visible',
    '[&_.modal-body]:overflow-visible',
    '[&_.modal-body]:text-slate-600',
    '[&_.modal-body]:last:!rounded-b-2xl',
    '[&_.modal-body.card]:border-0',
    '[&_.modal-body.card]:shadow-none',
    '[&_.modal-footer]:gap-2',
    '[&_.modal-footer]:border-0',
    '[&_.modal-footer]:border-t',
    '[&_.modal-footer]:border-solid',
    '[&_.modal-footer]:border-slate-100',
    '[&_.modal-footer]:bg-slate-50',
    '[&_.modal-footer]:!rounded-b-2xl',
    '[&_.modal-footer]:overflow-hidden',
    '[&_.modal-footer]:px-5',
    '[&_.modal-footer]:py-4',
    'max-sm:[&_.modal-footer]:flex-col-reverse',
    '[&_.btn]:inline-flex',
    '[&_.btn]:h-10',
    '[&_.btn]:min-w-[92px]',
    '[&_.btn]:items-center',
    '[&_.btn]:justify-center',
    '[&_.btn]:rounded-lg',
    '[&_.btn]:border-0',
    '[&_.btn]:px-4',
    '[&_.btn]:text-sm',
    '[&_.btn]:font-bold',
    '[&_.btn]:leading-none',
    '[&_.btn]:shadow-none',
    '[&_.btn-secondary]:bg-slate-100',
    '[&_.btn-secondary]:text-slate-700',
    '[&_.btn-secondary:hover]:bg-slate-200',
    '[&_.btn-light]:bg-slate-100',
    '[&_.btn-light]:text-slate-700',
    '[&_.btn-light:hover]:bg-slate-200',
    '[&_.btn-default]:bg-slate-100',
    '[&_.btn-default]:text-slate-700',
    '[&_.btn-default:hover]:bg-slate-200',
    '[&_.btn-primary]:bg-teal-700',
    '[&_.btn-primary]:text-white',
    '[&_.btn-primary:hover]:bg-teal-800',
    '[&_.btn-info]:bg-teal-700',
    '[&_.btn-info]:text-white',
    '[&_.btn-info:hover]:bg-teal-800',
    '[&_.btn-success]:bg-teal-700',
    '[&_.btn-success]:text-white',
    '[&_.btn-success:hover]:bg-teal-800',
    '[&_.btn-danger]:bg-red-600',
    '[&_.btn-danger]:text-white',
    '[&_.btn-danger:hover]:bg-red-700',
    'max-sm:[&_.modal-footer_.btn]:w-full'
  ].join(' ');

  constructor(private modalService: BsModalService, private activateRoute: ActivatedRoute, private route: Router) { }

  openConfirmDialog(data: confirmModalData): Promise<any> {
    const initialState: any = {
      animated: false,
      backdrop: "static",
      keyboard: false,
      id: 'CONFIRM_BOX',
    };
    const modalRef: any = this.modalService.show(ConfirmModalComponent, initialState);
    modalRef.content.setInput(data);
    return new Promise<any>((resolve, reject) => modalRef.content.onClose.subscribe((result: any) => resolve(result)));
  }

  openSearchModal(data: searchModal) {
    const initialState = {
      animated: true,
      class: 'm-0 search_div open'
    };
    this.modalRef = this.modalService.show(SearchModalComponent, initialState);
    this.modalRef.content.setInput(data);
    return new Promise<boolean>((resolve, reject) => this.modalRef.content.onClose.subscribe((result: any) => resolve(result)));
  }

  async openInfoModal(data: infoModalData, cssClass: string = 'modal-sm') {
    const initialState = {
      animated: true,
      id: 3,
      // class: cssClass,
      class: `${cssClass || ''} ${this.openModalTailwindClass}`.trim(),
    };
    this.modalRef = await this.modalService.show(InfoModalComponent, initialState,);
    this.modalRef.content.setInput(data);
    return new Promise<boolean>((resolve, reject) =>
      this.modalRef.content.onClose.pipe(take(1)).subscribe((result: any) => resolve(result))
    );
  }

  async openModal(componentData: any, data: any, cssClass: string = 'modal-sm', id = 1, backdrop = true) {
    const initialState: any = {
      animated: false,
      id: id,
      class: `${cssClass || ''} ${this.openModalTailwindClass}`.trim(),
      keyboard: backdrop
    };
    if (backdrop == false) {
      initialState.backdrop = 'static';
    }
    this.modalRef = await this.modalService.show(componentData, initialState);
    this.setCurrentUrl();
    this.modalRef.content.setInput(data);
    this.modalRef.content.onClose = new Subject();
    this.modalRef.onHide?.pipe(take(1)).subscribe((result: any) => { this.updateUrl() })
    return new Promise<boolean>((resolve, reject) =>
      this.modalRef.content?.onClose?.pipe(take(1)).subscribe((result: any) => { resolve(result) })
    );
  }
  setCurrentUrl() {
    this.currentUrl = { url: this.route.url, fragment: this.activateRoute.snapshot.fragment, queryParam: this.activateRoute.snapshot.queryParams };
  }
  updateUrl() {
    let url = this.currentUrl.url.split('#')[0] || '';
    url = url.split('?')[0] || '';
    if (url) {
      this.route.navigate([url.split('?')[0] || ''], { fragment: this.currentUrl.fragment, queryParams: this.currentUrl.queryParam })
    }
    this.currentUrl = { url: '' };
  }
  async showPreviewModal(data: emailConfigData, cssClass: string = 'modal-md', id = 1, backdrop = true) {
    return this.openModal(EmailSenderComponent, data, cssClass, id);
  }



  openModalTemplate(template: TemplateRef<any>, cssClass: string = 'modal-lg') {
    const initialState = {
      animated: true,
      id: 2,
      class: cssClass,
    };
    return this.modalRef = this.modalService.show(template, initialState);
  }
  close() {
    this.updateUrl();
    if (!isEmptyObj(this.modalRef))
      this.modalRef.hide()
  }

  isModalOpen() {
    const m = document.getElementsByClassName('modal-open');
    return m.length;
  }
}


